import { render, staticRenderFns } from "./SpreadLonger.vue?vue&type=template&id=b5cf636c&scoped=true"
import script from "./SpreadLonger.vue?vue&type=script&lang=js"
export * from "./SpreadLonger.vue?vue&type=script&lang=js"
import style0 from "./SpreadLonger.vue?vue&type=style&index=0&id=b5cf636c&prod&lang=less&scoped=true"
import style1 from "./SpreadLonger.vue?vue&type=style&index=1&id=b5cf636c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cf636c",
  null
  
)

export default component.exports